import SProviderLink from 'src/components/streaming/streamingtitlewithproviders/SProviderLink';
import styled from 'src/lib/styles/css';
import { isAfter, parse } from "date-fns";

//#region [Props]
type CinemaProviderProps = {
	movieId: string;
	className?: string;
	hasCinemaShows?: boolean;
	premiere?: string | Date;
};
//#endregion

//#region [Component]
export default function CinemaProvider({ movieId, className, hasCinemaShows, premiere }: CinemaProviderProps) {
	let premDate: Date | undefined;
	let text = "På kino";
	if (premiere && !/^0001/.test(premiere.toString())) {
		if (typeof premiere === 'string') {
			premDate = /^\d{4}[.-]\d{2}[.-]\d{2}/.test(premiere) ? parse(premiere.substring(0, 10).replace(/-/g, '.'), 'yyyy.MM.dd', new Date()) : undefined;
		} else {
			premDate = premiere;
		}

		if (premDate) {
			if (!hasCinemaShows && isAfter(premDate, new Date())) {
				return null; // do not show. No tickets and the premiere is in the future.
			}

			if (hasCinemaShows && isAfter(premDate, new Date())) {
				text = "Forsalg"; // there are tickets, but the premiere is in the future
			}
		}
	}
	return <SProviderLink to={`/film/${movieId}`} className={className}>{text}</SProviderLink>;
}
//#endregion

//#region [Styles]
//#endregion